import {
  InternalChromeConfig,
  fetchChromeData,
  getChromeContext as btswGetChromeContext,
} from '@amzn/aac-chrome-internal-api';
import { isBtswContext, isFromTrim, isFromBtswWc } from 'src/commons/utils';

export default async (): Promise<InternalChromeConfig> => {
  if (isBtswContext() || isFromTrim() || isFromBtswWc()) {
    return btswGetChromeContext();
  }

  const chromeData = await fetchChromeData();
  return chromeData.internalChromeConfig;
};
